var emitter = require('../base/emitter'),
	common = require('../base/common'),
	DragSlideshow = require('../components/dragslideshow/dragslideshow'),
	SliderImage = require('../components/slider-image');

function Linee(){
	
	var self = this;
	common.$window = $(window);

	self.onPage = false;
	emitter.on('linee:init', function(){

		self.onPage = true;
		self.init();
	})
	emitter.on('page:leave', function(){
		if(self.onPage)
			self.onPage = false;
	})

}

Linee.prototype.setImageSize = function(){

	var self = this;
	var winRatio = common.$window.width() / common.$window.height();
	var imgRatio = 1600/908;

	if(winRatio < imgRatio){
		self.$el.addClass('img-height');
	}else{
		self.$el.removeClass('img-height');
	}

}

Linee.prototype.initTimeline = function(){

	$('.timeline span').width( (100 / $('#linee-cover .slide').length) + '%' );

}

Linee.prototype.toggleSlideshow = function(){

		// if(self.slideshow.isFullscreen)
		// 	$('body').addClass('no-scroll');
		// else
		// 	$('body').removeClass('no-scroll');


	var self = this;
	if( self.slideshow.isFullscreen ) {
		self.$switchBtn.addClass('view-maxi');
		self.$wrap.addClass('is-list');
		self.slideshow.enable();
		emitter.emit('scroll:disable');
		$('body').addClass('no-scroll');

	}else {
		self.$switchBtn.removeClass('view-maxi');
		self.$wrap.removeClass('is-list');
		self.slideshow.disable();
		emitter.emit('scroll:enable');
		$('body').removeClass('no-scroll');
	}
	self.slideshow.toggle();

}

Linee.prototype.loadPage = function(page){

	var self = this;

	self.$wrap.addClass('loading-page');
	common.$body.addClass('no-scroll');
	common.$body.addClass('app-loading');
	TweenLite.to(window, 1, {scrollTo:{y:0}, ease:Power3.easeInOut});

	$.get(page, function(html){

	    history.pushState({obj:page}, '', page);
		common.$body.addClass('no-scroll');
		var $html = $('<div>'+html+'</div>');

		var $prevLink = $html.find('.navigation.prev-post');
		var $nextLink = $html.find('.navigation.next-post');

		if(!$prevLink.hasClass('hidden')){
			$('.navigation.prev-post').removeClass('hidden').html($prevLink.html())
			$('.navigation.prev-post').attr('href', $prevLink.attr('href'));
		}else
			$('.navigation.prev-post').addClass('hidden');

		if(!$nextLink.hasClass('hidden')){
			$('.navigation.next-post').removeClass('hidden').html($nextLink.html())
			$('.navigation.next-post').attr('href', $nextLink.attr('href'));
		}else
			$('.navigation.next-post').addClass('hidden');


		$('#linea-content').html($html.find('#linea-content').html());

		self.$wrap.removeClass('loading-page');
		common.$body.removeClass('no-scroll');
		emitter.emit('loader:load');

		setTimeout(function(){
			$('.c-slider-image').each(function(){
				new SliderImage($(this));
			})
		},100)

	},'html')

}

Linee.prototype.init = function(){

	var self = this;

	self.$el = $('#linee-cover');
	self.$slides = self.$el.find('.slide');
	self.currentSlide = 0;
	self.$wrap = $('#linee-cover-wrap');
	self.slideshow = null;
	self.$cover = $( '#linee-cover' );
	self.$switchBtn = self.$wrap.find( '.slider-switch' );

	self.setImageSize();
	self.initTimeline();
	emitter.on('page:resize', function(){
		self.setImageSize();
		self.initTimeline();
	})

	self.slideshow = new DragSlideshow( self.$cover.get(0), { 
		onToggle : function(){
			self.toggleSlideshow();
		},
		onMoveStart: function(index){},
		onMoveEnd: function(index){
			var currentSlide = $('#linee-cover .slide.current');
			var nextSlide = $('#linee-cover .slide').eq(index);
			currentSlide.removeClass('current');
			nextSlide.addClass('current');
		}
	});

	self.$switchBtn.on( 'click', function(e){
		e.preventDefault();
		TweenLite.to(window, 0.5, {scrollTo:{y:0}, onComplete: function(){
			self.toggleSlideshow();
		}});
	} );
	self.slideshow.disable();

	$('#linee-cover-wrap .navigation').on('click', function(e){

		e.preventDefault();
		self.slideshow.navigate($(this).hasClass('prev-post') ? false : true);
	})

	self.$slides.on('click', function(e){

		e.preventDefault();
		if(self.slideshow.isFullscreen || !$(this).hasClass('current')) return;
		var page = $(this).data('page');
		self.toggleSlideshow();
		self.loadPage(page);

	})

	self.$wrap.find('.navigation').on('click', function(e){
		e.preventDefault();
		var page = $(this).attr('href');
		self.loadPage(page);
	})

	$('.c-slider-image').each(function(){
		new SliderImage($(this));
	})

}

module.exports = Linee;


/** WEBPACK FOOTER **
 ** ./layouts/linee.js
 **/